module.exports = __webpack_public_path__ + "img/zone250350.f033b4bb.png";